module.exports = __webpack_public_path__ + "img/sumo-screenshot.51050225.png";